module.exports = __webpack_public_path__ + "static/media/om_eyeshape_downturned_brown.b03f1af1.png";